import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Carolina', 'Roberto', 'Valentina', 'Andrés', 'María', 'Diego', 'Camila', 'Felipe', 'Sofía', 'Matías', 'Daniela', 'Sebastián', 'Javiera', 'Tomás', 'Francisca', 'Nicolás', 'Catalina', 'Ignacio', 'Fernanda', 'Martín'];
const cities = ['Santiago', 'Valparaíso', 'Concepción', 'Vitacura', 'Arica', 'Viña Del Mar', 'Estación Central', 'Maipu', 'Las Condes', 'Temuco', 'Quinta Normal', 'La Serena', 'Rancagua', 'Punta Arenas', 'Antofagasta'];
function randomBetween(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function safeProductTitle(title: string) {
  return (title || '').replace(/internal preview/gi, '').replace(/dynamic/gi, '').replace(/preview/gi, '').replace(/\s{2,}/g, ' ').trim();
}
const HARDCODED_PRODUCT = {
  title: 'Método Silencio',
  priceText: '$4.990',
  thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/5ic8Sn8NZXtkyB1DMJyWGM/metodosilecio2_v2.webp'
};
export function SalesPop() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPop, setCurrentPop] = useState<{
    name: string;
    city: string;
    time: string;
    product: typeof HARDCODED_PRODUCT;
  } | null>(null);
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const nextTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showRandomPop = () => {
      const randomName = names[randomBetween(0, names.length - 1)];
      const randomCity = cities[randomBetween(0, cities.length - 1)];
      const minutesAgo = randomBetween(1, 15);
      const randomTime = `hace ${minutesAgo} minuto${minutesAgo === 1 ? '' : 's'}`;
      setCurrentPop({
        name: randomName,
        city: randomCity,
        time: randomTime,
        product: HARDCODED_PRODUCT
      });
      setIsVisible(true);
      hideTimerRef.current = setTimeout(() => {
        setIsVisible(false);
        nextTimerRef.current = setTimeout(showRandomPop, randomBetween(25000, 45000));
      }, randomBetween(4000, 5000));
    };
    nextTimerRef.current = setTimeout(showRandomPop, randomBetween(8000, 15000));
    return () => {
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      if (nextTimerRef.current) clearTimeout(nextTimerRef.current);
    };
  }, []);
  return <AnimatePresence data-id="element-239">
      {isVisible && currentPop && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 md:bottom-6 left-4 md:left-6 z-[45] max-w-[340px] w-[calc(100%-2rem)] bg-white rounded-2xl shadow-2xl border border-zen-beige overflow-hidden flex" data-id="element-240">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-dark/40 hover:text-slate-dark transition-colors z-10" aria-label="Cerrar notificación" data-id="element-241">
            <XIcon className="w-4 h-4" data-id="element-242" />
          </button>

          <div className="w-24 bg-zen-beige p-2 flex items-center justify-center shrink-0" data-id="element-243">
            <img src={currentPop.product.thumbnailUrl} alt={safeProductTitle(currentPop.product.title)} className="w-full h-auto object-cover rounded-lg shadow-sm" width={80} height={100} loading="lazy" decoding="async" data-id="element-244" />
          </div>

          <div className="p-4 flex flex-col justify-center flex-1" data-id="element-245">
            <div className="flex items-center gap-1.5 mb-1" data-id="element-246">
              <CheckCircleIcon className="w-3.5 h-3.5 text-green-500" data-id="element-247" />
              <span className="text-[10px] font-bold text-slate-dark/60 uppercase tracking-wider" data-id="element-248">
                Compra Verificada
              </span>
            </div>

            <p className="text-sm text-slate-dark leading-snug mb-2" data-id="element-249">
              <span className="font-bold" data-id="element-250">{currentPop.name}</span> de{' '}
              {currentPop.city} compró{' '}
              <span className="font-medium text-slate-dark/80" data-id="element-251">
                {safeProductTitle(currentPop.product.title)}
              </span>
            </p>

            <div className="flex items-center justify-between mt-auto" data-id="element-252">
              <span className="text-[11px] text-slate-dark/50 font-medium" data-id="element-253">
                {currentPop.time}
              </span>
              <span className="text-xs font-bold text-green-700 bg-green-100 px-2 py-0.5 rounded-md" data-id="element-254">
                {currentPop.product.priceText}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}